<template>
  <div :class="{ 'scrolled': scrolled, 'opened': openedMenu, 'closed': openedMenu && closedMenu }" class="header"  v-click-outside="closeMenu">
    <div class="container">
      <div class="logo">
        <div v-if="!defaultSize">
          <div :class="{'is-active': openedMenu}" class="hamburger--collapse cursor-pointer" @click="toggleMenu()">
            <div class="hamburger-box">
              <div class="hamburger-inner"></div>
            </div>
          </div>
        </div>
        <a href="#/"><img src="../assets/social-doctor-logo.svg" alt=""></a>
      </div>
      <div>
        <div v-if="defaultSize" class="accesButton" @click="goToContact()">{{ $t('header.contacto') }}</div>
        <div v-if="defaultSize" @click="goTo()" class="accesButton login">{{ $t('header.acceder') }}</div>
        <div>
          <div class="selectLang" v-click-outside="closeSelect">
            <div class="selected" @click="toggleSelect()"><span>{{ language.selected }}</span><i class="fas fa-sort-down mt--5"></i></div>
            <div v-show="openedSelect" class="options">
              <div v-for="(option, index) in language.options" :key="index" :class="{'active': language.selected === option.value.toUpperCase()}" @click="changeLanguage(option.value)">{{option.text}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="openedMenu" class="container-mobile">
      <div v-if="!defaultSize" class="accesButton" @click="goToContact()">{{ $t('header.contacto') }}</div>
      <div v-if="!defaultSize" @click="goTo()" class="accesButton login">{{ $t('header.acceder') }}</div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import i18n from '../plugins/i18n.js'
export default {
  name: 'Header',
  props: {
    deviceType: String
  },
  data: () => ({
    scrolled: false,
    defaultSize: true,
    language: {
      selected: i18n.locale.toUpperCase(),
      options: [
        {
          value: 'es',
          text: 'Español (ES)'
        },
        {
          value: 'en',
          text: 'English (EN)'
        },
        {
          value: 'fr',
          text: 'Français (FR)'
        },
        {
          value: 'de',
          text: 'Deutsche (DE)'
        },
        {
          value: 'pt',
          text: 'Português (PT)'
        }
      ]
    },
    openedSelect: false,
    openedMenu: false,
    closedMenu: false
  }),
  computed: mapGetters(['getDeviceType']),
  methods: {
    goTo () {
      const { getDeviceType } = this
      if (getDeviceType === 'Android') {
        window.location.href = this.$store.state.urlAndroid
      }
      if (getDeviceType === 'iOS') {
        window.location.href = this.$store.state.urlIos
      }
      if (getDeviceType === 'Desktop') {
        window.location.href = this.$store.state.urlDesktop
      }
    },
    goToContact () {
      var elmnt = document.getElementById('contact')
      elmnt.scrollIntoView()
    },
    handleScroll () {
      if (document.body.scrollTop < 50 && this.scrolled) {
        this.scrolled = false
      }
      if (document.body.scrollTop >= 50 && !this.scrolled) {
        this.scrolled = true
      }
    },
    toggleSelect () {
      this.openedSelect = !this.openedSelect
    },
    toggleMenu () {
      if (this.openedMenu) {
        this.closedMenu = true
        setTimeout(() => {
          this.openedMenu = false
          this.closedMenu = false
        }, 800)
      } else {
        this.openedMenu = true
      }
    },
    closeSelect () {
      this.openedSelect = false
    },
    changeLanguage (option) {
      i18n.locale = option
      this.language.selected = option.toUpperCase()
      this.closeSelect()
    },
    closeMenu () {
      this.closedMenu = true
      setTimeout(() => {
        this.openedMenu = false
        this.closedMenu = false
      }, 800)
    },
    checkScreenSize () {
      if (window.innerWidth > 870 && !this.defaultSize) {
        this.defaultSize = true
      }
      if (window.innerWidth <= 770 && this.defaultSize) {
        this.defaultSize = false
      }
    }
  },
  created () {
    document.body.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.checkScreenSize)
    this.checkScreenSize()
  },
  destroyed () {
    document.body.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style lang="scss" scoped>
.header {
  position: absolute;
  top: 0;
  left: 0;
  width: calc(100% - 9px);
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  -webkit-transition: background 200ms ease-in-out;
  -moz-transition: background 200ms ease-in-out;
  -ms-transition: background 200ms ease-in-out;
  -o-transition: background 200ms ease-in-out;
  transition: background 200ms ease-in-out;

  &.scrolled {
    background: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(5px);
    border-bottom: 2px solid #fff;
  }

  .container {
    height: 100%;
    display: flex;
    justify-content: space-between;

    .logo {
      display: flex;
      align-items: center;
    }

    > div:nth-child(2) {
      display: flex;
      align-items: center;

      .accesButton {
        font-weight: 700;
        font-size: 19px;
        margin-right: 20px;
        color: #444D67;
        cursor: pointer;

        &.login {
          color: #4AC4D0;
        }
      }
    }

    .selectLang {
      position: relative;
      cursor: pointer;
      color: #7A8096;

      .selected {
        width: 56px;
        height: 30px;
        background: #FFFFFF;
        border: 1px solid #DBDCE1;
        border-radius: 8px;
        padding: 1px 10px 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .options {
        position: absolute;
        top: 100%;
        right: 0;
        max-height: 200px;
        margin-top: 5px;
        padding: 5px;
        background: #fff;;
        border: 1px solid #DBDCE1;
        box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
        border-radius: 3px;
        width: auto;
        overflow: auto;
        z-index: 1;

        div {
          width: 100%;
          white-space: nowrap;
          padding: 4px 10px;
          border-radius: 3px;
          text-align: left;

          &.active {
            color: #4AC4D0;
          }

          &:hover {
            background: #F7F8FD;
          }
        }
      }
    }
  }

  @media(max-width: 1200px) {
    .container > div:nth-child(2) .accesButton {
        font-size: 16px;
    }
  }
}

@media(max-width: 770px) {
  .header {
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;

    &.scrolled {
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);
    }

    .container {
      align-items: flex-start;
      padding-top: 20px;
      height: auto;
    }

    .container-mobile {
      opacity: 0;
      width: 100%;
      margin-top: 5px;

      .accesButton {
        font-weight: 700;
        text-align: left;
        margin-top: 20px;
        font-size: 16px;
        padding-left: 50px;
        color: #444D67;
        cursor: pointer;

        &.login {
          color: #4AC4D0;
        }
      }
    }

    &.opened {
      height: 170px;
      background: rgba(255, 255, 255, 0.85);
      backdrop-filter: blur(5px);
      border-bottom: 2px solid #fff;

      animation: showMenu 250ms 0ms ease-in forwards;

      .container-mobile {
        opacity: 0;

        animation: showLinks 250ms 280ms ease-in forwards;
      }
    }

    @keyframes showMenu {
      from {
        height: 70px;
      }
      to {
        height: 170px;
      }
    }
    @keyframes showLinks {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }

    &.closed {
      height: 170px;
      background: rgba(255, 255, 255, 0.85);
      backdrop-filter: blur(5px);
      border-bottom: 2px solid #fff;

      animation: hideMenu 250ms 280ms ease-in forwards;

      .container-mobile {
        opacity: 1;

        animation: hideLinks 250ms 0ms ease-in forwards;
      }
    }

    @keyframes hideMenu {
      from {
        height: 170px;
      }
      to {
        height: 70px;
      }
    }

    @keyframes hideLinks {
      from {
        opacity: 1;
      }
      to {
        opacity: 0;
      }
    }
  }
}

@media(max-width: 500px) {
  .header {
    width: 100%;

    &.scrolled {
      background: rgba(255, 255, 255, 1);
      backdrop-filter: blur(5px);
      border-bottom: 2px solid #fff;
    }

    &.opened,
    &.closed {
      background: rgba(255, 255, 255, 1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue